import { render } from "./SimpleTableForEdit.vue?vue&type=template&id=347752fe&scoped=true"
import script from "./SimpleTableForEdit.vue?vue&type=script&lang=ts"
export * from "./SimpleTableForEdit.vue?vue&type=script&lang=ts"

import "./SimpleTableForEdit.vue?vue&type=style&index=0&id=347752fe&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-347752fe"

export default script